import { setShowUploadModal } from '../State/showUploadModal';

export default () => async (dispatch) => {
  
  dispatch(setShowUploadModal(false));

}